import dayjs from 'dayjs'

export const getDurationString = (duration: number) => {
  if (duration <= 0) return '0秒'
  const d = dayjs.duration(duration, 'seconds')
  const time = {
    days: d.days(),
    hours: d.hours(),
    minutes: d.minutes(),
    seconds: d.seconds(),
  }

  return `${time?.days ? `${time?.days}天` : ''}${time?.hours ? `${time?.hours}小时` : ''}${
    time?.minutes ? `${time?.minutes}分` : ''
  }${time?.seconds ? `${time?.seconds}秒` : ''}`
}
